import WidgetClassContentItemModel from '../../generated/types/model/resource/WidgetClassContentItemModel';

export default class WidgetClassContentItemViewModel extends WidgetClassContentItemModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
